var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLearning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1757654904440,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 12299,
    width: 24,
    height: 24,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M539.648 289.792l390.144 125.952c18.432 5.632 17.92 43.52 0 49.664l-390.144 125.952c-17.92 5.632-31.232 5.632-49.664 0L100.352 464.896c-17.92-5.632-18.432-43.52 0-49.664l390.144-125.952c18.432-5.632 31.232-5.12 49.152 0.512z m0 0",
    fill: "#07c160",
    "p-id": 12300
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M757.248 565.76v179.2c-59.904 37.376-146.432 60.928-243.2 60.928s-183.296-23.552-243.2-60.928v-179.2l218.624 70.656c18.432 5.632 31.232 5.632 49.664 0l218.112-70.656zM182.784 484.864s-26.624-2.048-35.84 77.824l-0.512 2.56c-11.776 6.144-19.968 17.408-19.968 30.72 0 10.24 5.12 19.456 12.8 26.112-7.68 59.392-16.896 115.2-28.16 151.04 0 0-6.144 29.696 8.192 30.72 14.336 0.512 91.136 0 91.136 0s15.872-4.608 9.216-29.696c0 0-23.552-68.608-28.16-151.552 8.192-6.656 13.312-15.872 13.312-26.624 0-11.264-6.144-21.504-15.36-28.16 0-34.816 5.632-43.008 23.552-70.144l-30.208-12.8z m0 0",
    fill: "#07c160",
    "p-id": 12301
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearning);
export default __webpack_public_path__ + "static/media/learning.a9aad104.svg";
export { ForwardRef as ReactComponent };